module.exports = __webpack_public_path__ + "img/10_wind.3af4b5a3.jpg";